// This is a temporary file to migrate global atoms to TypeScript.
// Once migration is complete, merge into globalAtoms.ts and delete this file.
// The underscore prefix follows the pattern established by _editorAtoms.ts

import { atom, selector } from 'recoil'
import type { GetUser } from '@messenger/types'
import { userTypes } from '@messenger/consts'
import { roleAtom } from './globalAtoms'

/**
 * Stores the authenticated user's data from the /user API endpoint.
 * Set during authentication in Auth0.tsx provider.
 * Uses GetUser type from @messenger/types which matches backend response.
 */
export const userAtom = atom<GetUser | null>({
  key: 'user',
  default: null,
})

/**
 * Whether the signed-in user acts as an admin: the messenger-user role, a
 * super or corporation admin, or a user acting as admin. `useIsAdmin` is the
 * hook form of the same rule; a selector needs it here.
 */
export const isAdminUser = (role: unknown, user: GetUser | null): boolean =>
  role === 'messenger-user' ||
  user?.type === userTypes.superAdmin ||
  user?.type === userTypes.corporationAdmin ||
  !!user?.actAsAdmin

export const isAdminUserSelector = selector<boolean>({
  key: 'isAdminUser',
  get: ({ get }) => isAdminUser(get(roleAtom), get(userAtom)),
})
